import { useQuery } from '@tanstack/react-query';
import { getCart } from '../services/cartService';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FEATURE_FLAG_KEYS } from '../../../../../config/growthbook';

const CART_QUERY_KEY = '/api/resilience/v1/carts/my';

export const useCart = () => {
  const crsEnableSelfServe = useFeatureIsOn(
    FEATURE_FLAG_KEYS.CRS_ENABLE_SELF_SERVE
  );

  return useQuery({
    queryKey: [CART_QUERY_KEY],
    queryFn: () => getCart().then((res) => res.data ?? null),
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: crsEnableSelfServe,
  });
};

useCart.queryKey = CART_QUERY_KEY;
